import { useEffect, useState } from 'react';

export const useAdvancedSecurity = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isTabVisible, setIsTabVisible] = useState(true);
  const [warnings, setWarnings] = useState([]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      const isVisible = document.visibilityState === 'visible';
      setIsTabVisible(isVisible);
      
      if (!isVisible) {
        setWarnings(prev => [...prev, {
          type: 'tab_switch',
          timestamp: new Date().toISOString()
        }]);
      }
    };

    const handleFullscreenChange = () => {
      const isFullscreenNow = document.fullscreenElement !== null;
      setIsFullscreen(isFullscreenNow);
      
      if (!isFullscreenNow) {
        setWarnings(prev => [...prev, {
          type: 'fullscreen_exit',
          timestamp: new Date().toISOString()
        }]);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    document.addEventListener('fullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  const requestFullscreen = async () => {
    try {
      await document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } catch (error) {
      console.error('Failed to enter fullscreen:', error);
    }
  };

  const exitFullscreen = async () => {
    try {
      await document.exitFullscreen();
      setIsFullscreen(false);
    } catch (error) {
      console.error('Failed to exit fullscreen:', error);
    }
  };

  return {
    isFullscreen,
    isTabVisible,
    warnings,
    requestFullscreen,
    exitFullscreen
  };
}; 